import SelectPacking from 'components/BusinessLogic/Product/SelectPacking';
import Monetary from 'components/UI/Data/Monetary';
import Quality from 'components/UI/Quality';
import BottomSheet, {
  SheetSummary,
} from 'components/UI/Responsive/BottomSheet';
import { memo, useState } from 'react';
import { useBuyIntentionOfferPurchase } from 'screens/Products/components/BuyIntentionActions/useBuyIntentionOfferPurchase';
import ProductCardImage from 'screens/Products/components/ProductItem/components/ProductCardImage';
import { ModesProps } from 'screens/Products/components/ProductItem/Modes/props';
import { OfferNotes, OfferTags, useOfferSubtotal } from './OfferInfo';
import {
  OfferQuantity,
  OfferSaleTypes,
  OfferTrolleyLimit,
} from './OfferPurchaseControls';
import * as S from './offerStyles';

function BuyIntentionOfferCard({
  product,
  packingSelected,
  getLowPrice,
  handleOnSelectPacking,
  openImage,
  buy,
  selectedTypeSale,
  onChangePackingTypeSale,
}: ModesProps) {
  const [isOpen, setOpen] = useState(false);
  const purchase = useBuyIntentionOfferPurchase({
    product,
    packingSelected,
    selectedTypeSale,
    onChangePackingTypeSale,
    onClickFastBuy: buy,
    onInvalidQuantity: () => setOpen(true),
  });
  const subtotal = useOfferSubtotal(product.id);
  const isSelected = purchase.quantityPacking > 0;

  return (
    <li>
      <S.CardButton
        type="button"
        data-selected={isSelected}
        onClick={() => setOpen(true)}
      >
        <S.CardHeader>
          <S.CardTitle>{product.longName}</S.CardTitle>
          {isSelected && (
            <S.CardTotal>
              <Monetary symbol value={subtotal} />
            </S.CardTotal>
          )}
        </S.CardHeader>
        {product.conceptName && <S.Concept>{product.conceptName}</S.Concept>}
        <S.Secondary>{product.siteName}</S.Secondary>
        <S.CardDetails>
          <Quality quality={product.quality} />
          <span>
            {'A partir de '}
            <Monetary symbol value={getLowPrice} />
          </span>
        </S.CardDetails>
        <OfferTags product={product} />
        {isSelected && (
          <S.CardTag>
            {`Selecionada: ${purchase.quantityPacking} ${purchase.textInputTypeSale}`}
          </S.CardTag>
        )}
      </S.CardButton>

      <BottomSheet
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        title={product.longName}
        summary={<SheetSummary>{product.siteName}</SheetSummary>}
        keepMounted
        footer={
          <S.SheetAction type="button" onClick={() => setOpen(false)}>
            Concluir
          </S.SheetAction>
        }
      >
        <S.SheetBody>
          <S.SheetImage>
            <ProductCardImage
              images={product.imagesFormatted}
              imageByProducer={product.images.length > 0 && !product.isLkpOffer}
              maxHeight="120px"
              open={openImage}
            />
          </S.SheetImage>

          <S.DetailList>
            <dt>Qualidade</dt>
            <dd>
              <Quality quality={product.quality} />
            </dd>
            <dt>Embalagem</dt>
            <dd>
              <SelectPacking
                offerId={product.offerId}
                onSelect={handleOnSelectPacking}
                packings={product.packings}
                value={packingSelected.id}
              />
            </dd>
            <dt>Múltiplo</dt>
            <dd>{packingSelected?.multiple ?? '-'}</dd>
            <dt>Cores</dt>
            <dd>{product.colors || '-'}</dd>
            <dt>Dimensão</dt>
            <dd>{product.dimension || '-'}</dd>
          </S.DetailList>

          <OfferTags product={product} />
          <OfferNotes product={product} />

          <S.SheetSection>
            <h3>Tipo de venda</h3>
            <OfferSaleTypes
              product={product}
              packingSelected={packingSelected}
              selectedTypeSale={selectedTypeSale}
              purchase={purchase}
            />
          </S.SheetSection>

          <S.SheetSection>
            <h3>Quantidade</h3>
            <OfferQuantity product={product} purchase={purchase} />
          </S.SheetSection>

          {isSelected && (
            <S.CardHeader>
              <S.Secondary>Subtotal</S.Secondary>
              <S.Subtotal>
                <Monetary symbol value={subtotal} />
              </S.Subtotal>
            </S.CardHeader>
          )}
        </S.SheetBody>
      </BottomSheet>

      <OfferTrolleyLimit
        selectedTypeSale={selectedTypeSale}
        purchase={purchase}
      />
    </li>
  );
}

export default memo(BuyIntentionOfferCard);
